import classnames from "classnames";
import React, { type ReactNode } from "react";
import { Label } from "reactstrap";
import type { InputType } from "reactstrap/lib/Input";
import type { WrappedFieldProps } from "redux-form";
import FormFeedback from "./FormFeedbackStyled";
import type { FormLabelType } from "./FormLabelRenderer";
import {
  StyledFormGroup,
  StyledInputWrapper,
  StyledTooltipWrapper,
} from "src/shared/forms/formrenderers/FormRendererNew";
import { FormTextRenderer } from "src/shared/forms/formrenderers/FormTextRenderer";

export interface IFormRendererProps extends WrappedFieldProps {
  label: FormLabelType;
  type?: InputType;
  formText?: ReactNode | ((value: any) => ReactNode);
  tooltip?: ReactNode;
  alwaysShowLabel?: boolean;
  disableErrors?: boolean;
  children?: ReactNode;
}

export const FormRenderer = ({
  type,
  alwaysShowLabel,
  disableErrors,
  children,
  formText,
  tooltip,
  input: { value },
  label,
  meta: { error, warning, submitting },
}: IFormRendererProps) => {
  if (type === "radio" || type === "checkbox") {
    return (
      <div className="form-check">
        <Label
          className={classnames({
            "form-check-label": true,
            "is-invalid": !disableErrors && !!error,
          })}
        >
          {children}
          {label}
          {tooltip && <span className="ml-1">{tooltip}</span>}
        </Label>
        {!disableErrors &&
          ((error && <FormFeedback>{error}</FormFeedback>) ||
            (warning && <FormFeedback>{warning}</FormFeedback>))}
        <FormTextRenderer formText={formText} value={value} />
      </div>
    );
  } else {
    let className = "";
    if (alwaysShowLabel || value || type === "select") {
      if (submitting) {
        className = "form-group-readonly";
      }
    } else {
      className = "form-group-hide-label";
    }

    return (
      <StyledFormGroup className={className}>
        <StyledInputWrapper>
          <Label>{label}</Label>
          {children}
          {!disableErrors &&
            ((error && <FormFeedback>{error}</FormFeedback>) ||
              (warning && <FormFeedback>{warning}</FormFeedback>))}
          <FormTextRenderer formText={formText} value={value} />
        </StyledInputWrapper>
        {tooltip && <StyledTooltipWrapper>{tooltip}</StyledTooltipWrapper>}
      </StyledFormGroup>
    );
  }
};

/**
 * @deprecated
 */
export default FormRenderer;
